export default __webpack_public_path__ + "static/media/spr-background-large.e07fddb4.jpg";